import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoginRequest, AuthResponse, User } from '../../models/auth.model';
import { API_BASE } from './api-constants';

@Injectable({ providedIn: 'root' })
export class AuthApiService {
  constructor(private http: HttpClient) {}

  /** POST /authenticate - login com email e senha */
  authenticate(body: LoginRequest): Observable<AuthResponse> {
    return this.http.post<AuthResponse>(`${API_BASE}/authenticate`, body);
  }

  /** POST /refresh_authenticate - renovar token */
  refreshAuthenticate(refreshToken: string): Observable<AuthResponse> {
    return this.http.post<AuthResponse>(`${API_BASE}/refresh_authenticate`, {
      refreshToken,
    });
  }

  /** GET /authenticate/me - usuário atual */
  getMe(): Observable<User> {
    return this.http.get<User>(`${API_BASE}/authenticate/me`);
  }

  googleAuthenticate(token: string): Observable<AuthResponse> {
    return this.http.post<AuthResponse>(`${API_BASE}/auth/google`, { token });
  }

  register(body: {name: string; email: string; password: string}): Observable<unknown> {
    return this.http.post(`${API_BASE}/users/register`, body);
  }

  portalConfig(): Observable<{googleClientId: string}> {
    return this.http.get<{googleClientId: string}>(`${API_BASE}/portal/config`);
  }
}
